// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RequestsPermissionsBlock__title-header-f1b324 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
}

.RequestsPermissionsBlock__title-fde652 {
  font: var(--font-subtitle-2);
  color: var(--addition-50_70);
  letter-spacing: var(--font-spacing-subtitle-1);
}

.RequestsPermissionsBlock__decline-button-d523c9 {
  padding-top: 7px;
  padding-bottom: 7px;
  padding-inline-start: 8px;
  padding-inline-end: 12px;
  border-radius: 0;
  border: none;
  background: transparent;
  cursor: pointer;
}

.RequestsPermissionsBlock__decline-button-d523c9:hover {
  border: none;
  background: transparent;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/FullScreenCallView/Shared/AnimatedRightPanel/RequestedPermissionsPanel/components/RequestsPermissionsBlock/RequestsPermissionsBlock.styles.m.css"],"names":[],"mappings":"AACA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AAAF;;AAGA;EACE,4BAAA;EACA,4BAAA;EACA,8CAAA;AAAF;;AAIA;EACE,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,wBAAA;EACA,gBAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;AADF;;AAIA;EACE,YAAA;EACA,uBAAA;AADF","sourcesContent":["\n.title-header {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 16px;\n}\n\n.title {\n  font: var(--font-subtitle-2);\n  color: var(--addition-50_70);\n  letter-spacing: var(--font-spacing-subtitle-1);\n}\n\n\n.decline-button {\n  padding-top: 7px;\n  padding-bottom: 7px;\n  padding-inline-start: 8px;\n  padding-inline-end: 12px;\n  border-radius: 0;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n}\n\n.decline-button:hover{\n  border: none;\n  background: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title-header": `RequestsPermissionsBlock__title-header-f1b324`,
	"titleHeader": `RequestsPermissionsBlock__title-header-f1b324`,
	"title": `RequestsPermissionsBlock__title-fde652`,
	"decline-button": `RequestsPermissionsBlock__decline-button-d523c9`,
	"declineButton": `RequestsPermissionsBlock__decline-button-d523c9`
};
module.exports = ___CSS_LOADER_EXPORT___;
